import type { PaymentMethod } from "@jti/evo-client";
import type { PgsPaymentMethod } from "@jti/fe-common";

export const translatedPaymentMethodsEvo = (data?: PaymentMethod[]): PgsPaymentMethod[] => {
  if (!data) return [];
  return data.map((paymentMethod) => ({
    code: paymentMethod.code ?? "",
    description: paymentMethod.description ?? "",
    icon: paymentMethod.icon ?? "",
    tokenizable: paymentMethod.tokenizable ?? false,
    title: paymentMethod.title ?? "",
    enabled: paymentMethod.enabled ?? true,
  }));
};
